import { FaBolt, FaChartBar, FaComments, FaLightbulb, FaMoneyBillWave, FaSync } from 'react-icons/fa';

const differentiators = [
  { icon: FaChartBar, title: 'Weekly scorecards', copy: 'CPA, ROAS, and pipeline updates every Friday. No surprises.' },
  {
    icon: FaLightbulb,
    title: 'All channels, one pod',
    copy: 'Design, dev, SEO, paid media, and content move as a single squad.',
  },
  {
    icon: FaBolt,
    title: 'Launch in 14 days',
    copy: 'Ship conversion-ready assets fast and iterate off real data.',
  },
  {
    icon: FaSync,
    title: 'Weekly experiments',
    copy: 'Structured sprints ensure something new ships every seven days.',
  },
  {
    icon: FaMoneyBillWave,
    title: 'Revenue-first goals',
    copy: 'Targets tie to demos, sales, or ARR — not impressions.',
  },
  {
    icon: FaComments,
    title: 'Direct access to specialists',
    copy: 'Slack + Loom updates mean you speak with the strategist doing the work, not just an account manager.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-6xl px-6">
        <p className="text-sm uppercase tracking-[0.2em] text-slate-500">Why partners stay</p>
        <h2 className="mt-2 text-3xl font-semibold text-slate-900 md:text-4xl">Why teams stick with Anorc</h2>
        <p className="mt-4 max-w-3xl text-slate-600">Here’s what working with us actually feels like.</p>

        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {differentiators.map(({ icon: Icon, title, copy }) => (
            <div
              key={title}
              className="rounded-3xl border border-slate-200 bg-gradient-to-br from-white to-slate-50 p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
            >
              <Icon className="text-3xl text-blue-500" />
              <h3 className="mt-4 text-lg font-semibold text-slate-900">{title}</h3>
              <p className="mt-2 text-sm text-slate-600">{copy}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
